module.exports = __webpack_public_path__ + "static/img/pattern1.c6031f6.svg";